import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
import mixins from './mixins'
import filters from './filters'

window.selector_id = window.location.pathname.split('/')[1]

Vue.use(BootstrapVue)


Vue.mixin(mixins)
Vue.mixin(filters)



// Axios config
axios.defaults.baseURL = 'https://www.woningselector.nl/api/woningselectors'
Vue.use(VueAxios, axios)


Vue.config.productionTip = false




new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

